// @frame/sdk/tv — the TV side of modules (widgets).
// Widget bundles don't include this module; they use the runtime's single copy
// (the build pipeline wires the import to window.__frame).
import type { ComponentType } from 'preact';

export * from './hooks.ts';
export * from '../shared.ts';
export * from './ui.tsx';
export { iconNames, type IconName } from './icons.tsx';
export { RuntimeContext, WidgetContext, type RuntimeApi, type WidgetInfo, type WidgetSize, type OpenAppOptions, type Mode, type AudioPlayback } from './context.ts';

export type WidgetComponent = ComponentType<Record<string, never>>;

/** Default export of a module's client.tsx: { 'widget-name': Component }. Names match the widgets in defineModule. */
export function defineWidgets<T extends Record<string, WidgetComponent>>(widgets: T): T {
  return widgets;
}
